import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import ReactGA from 'react-ga';
import WebFont from 'webfontloader';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { persistor, store } from './redux/store';
import { config } from './constants';
// Main Component
import Routes from './containers/App/routes';
// Styles
import './assets/styles/root.css';

// Import Fonts
WebFont.load({
  custom: {
    families: ['NeueHaasUnicaW1G-Regular:n4']
  }
});

// Import Analytics
if (config.GOOGLE_ANALYTICS_TRACKING_ID !== '') {
  ReactGA.initialize(config.GOOGLE_ANALYTICS_TRACKING_ID, {
    debug: config.DEV
  });
}

render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js